import { render, staticRenderFns } from "./BillingForm.vue?vue&type=template&id=127cad84&"
import script from "./BillingForm.vue?vue&type=script&lang=ts&"
export * from "./BillingForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports